import React, { useState } from "react";
import { Link } from "react-router";
import { EyeCloseIcon, EyeIcon } from "../Icons";

function SignUpForm() {
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const [signUpData, setSignUpData] = useState({
    first_name: "",
    last_name: "",
    email: "",
    phone_number: "",
    department: "",
    region: "",
    password: "",
    confirm_password: "",
  });

  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState("");

  const handleChange = (e) => {
    const { id, value } = e.target;
    setSignUpData((prevData) => ({ ...prevData, [id]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setMessage("");

    try {
      const response = await fetch(`/api/registration/staff/`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(signUpData),
      });

      const data = await response.json();

      if (response.ok) {
        setMessage(data.message || "You have successfully registered.");
        setSignUpData({
          first_name: "",
          last_name: "",
          email: "",
          phone_number: "",
          department: "",
          region: "",
          password: "",
          confirm_password: "",
        });
        setTimeout(() => {
          window.location.href = `/dashboard/`;
        }, 1000);
      } else {
        let errorMessage = "An error occurred. Please try again.";

        if (data.error) {
          errorMessage = data.error;
        } else if (typeof data === "object") {
          const firstKey = Object.keys(data)[0];
          const firstError = data[firstKey][0];
          errorMessage = firstError;
        }

        setMessage(errorMessage);
      }
    } catch (error) {
      setMessage("Network error: " + error.message);
    }

    setIsLoading(false);
  };

  return (
    <div className="flex flex-col flex-1 w-full">
      <div className="flex flex-col justify-center flex-1 w-full max-w-md mx-auto">
        <div>
          <div className="mb-5 text-center">
            <h1 className="mb-2 font-semibold text-gray-800 text-2xl">
              Sign Up
            </h1>
            <p className="text-sm text-gray-500">
              Enter your email and password to sign up!
            </p>
          </div>
          <div className="mx-auto bg-gray-100 rounded-lg shadow-lg p-7">
            <form onSubmit={handleSubmit}>
              <div className="space-y-5">
                <div className="grid grid-cols-1 gap-5 sm:grid-cols-2">
                  <div className="sm:col-span-1">
                    <label>
                      First Name<span className="text-red-500">*</span>
                    </label>
                    <input
                      value={signUpData.first_name}
                      required
                      type="text"
                      id="first_name"
                      name="first_name"
                      placeholder="Enter your first name"
                      className="mt-1 w-full p-2 border-gray-300 focus:border-[#0166b1]"
                      onChange={handleChange}
                    />
                  </div>

                  <div className="sm:col-span-1">
                    <label>
                      Last Name<span className="text-red-500">*</span>
                    </label>
                    <input
                      value={signUpData.last_name}
                      required
                      type="text"
                      id="last_name"
                      name="last_name"
                      placeholder="Enter your last name"
                      className="mt-1 w-full p-2 border-gray-300 focus:border-[#0166b1]"
                      onChange={handleChange}
                    />
                  </div>
                </div>
                <div>
                  <label>
                    Email<span className="text-red-500">*</span>
                  </label>
                  <input
                    value={signUpData.email}
                    required
                    type="email"
                    id="email"
                    name="email"
                    placeholder="Enter your email"
                    className="mt-1 w-full p-2 border-gray-300 focus:border-[#0166b1]"
                    onChange={handleChange}
                  />
                </div>
                <div className="grid grid-cols-1 gap-5 sm:grid-cols-2">
                  <div className="sm:col-span-1">
                    <label>
                      Department<span className="text-red-500">*</span>
                    </label>
                    <input
                      value={signUpData.department}
                      required
                      type="text"
                      id="department"
                      name="department"
                      placeholder="Enter your department"
                      className="mt-1 w-full p-2 border-gray-300 focus:border-[#0166b1]"
                      onChange={handleChange}
                    />
                  </div>

                  <div className="sm:col-span-1">
                    <label>
                      Region<span className="text-red-500">*</span>
                    </label>
                    <input
                      value={signUpData.region}
                      required
                      type="text"
                      id="region"
                      name="region"
                      placeholder="Enter your region"
                      className="mt-1 w-full p-2 border-gray-300 focus:border-[#0166b1]"
                      onChange={handleChange}
                    />
                  </div>
                </div>
                <div>
                  <label>
                    Password<span className="text-red-500">*</span>
                  </label>
                  <div className="relative">
                    <input
                      required
                      placeholder="Enter your password"
                      type={showPassword ? "text" : "password"}
                      className="mt-1 p-2 w-full border-gray-500 focus:border-indigo-600"
                      onChange={handleChange}
                      value={signUpData.password}
                      id="password"
                    />
                    <span
                      onClick={() => setShowPassword(!showPassword)}
                      className="absolute z-30 -translate-y-1/2 cursor-pointer right-4 top-1/2"
                    >
                      {showPassword ? (
                        <EyeIcon className="fill-gray-500" />
                      ) : (
                        <EyeCloseIcon className="fill-gray-500" />
                      )}
                    </span>
                  </div>
                </div>
                <div>
                  <label>
                    Confirm Password<span className="text-red-500">*</span>
                  </label>
                  <div className="relative">
                    <input
                      value={signUpData.confirm_password}
                      required
                      placeholder="Confirm your password"
                      type={showConfirmPassword ? "text" : "password"}
                      className="mt-1 p-2 w-full border-gray-500 focus:border-indigo-600"
                      onChange={handleChange}
                      id="confirm_password"
                    />
                    <span
                      onClick={() =>
                        setShowConfirmPassword(!showConfirmPassword)
                      }
                      className="absolute z-30 -translate-y-1/2 cursor-pointer right-4 top-1/2"
                    >
                      {showConfirmPassword ? (
                        <EyeIcon className="fill-gray-500" />
                      ) : (
                        <EyeCloseIcon className="fill-gray-500" />
                      )}
                    </span>
                  </div>
                </div>

                <div>
                  <button
                    type="submit"
                    className="flex items-center justify-center w-full px-4 py-3 text-sm font-medium text-white transition rounded-lg bg-blue-500 shadow-theme-xs hover:bg-blue-600"
                  >
                    {isLoading ? "Submitting..." : "Sign Up"}
                  </button>
                </div>
              </div>
            </form>

            {message && (
              <div className="max-w-lg mx-auto p-4 mb-4 text-center text-white bg-indigo-600 rounded">
                {message}
              </div>
            )}

            <div className="mt-5">
              <p className="text-sm font-normal text-center text-gray-700 sm:text-start">
                Already have an account?
                <Link
                  to="/dashboard/signin"
                  className="text-blue-500 hover:text-blue-600"
                >
                  Sign In
                </Link>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SignUpForm;
